import { useEffect, useContext } from "react";
import { AppSettings } from "./../../config/app-settings.js";
import { useNavigate } from "react-router-dom";
import { homePage } from "../../config/configSPA.js";
import { getDataUser } from "../../config/apiSPA.js";

function Logingin() {
  const context = useContext(AppSettings);
  const navigate = useNavigate();
  const authCheck = async () => {
    try {
      const u = await getDataUser();
      if (!u) {
        navigate("/login");
      } else {
        navigate(homePage);
      }
    } catch (error) {
      navigate("/login");
    }
  };
  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");
    authCheck();
    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);

  return (
    <div className="login">
      <div className="login-content">
        <h1 className="text-center">WELCOME</h1>
        <div className="text-inverse text-opacity-50 text-center mb-4">Please Wait....</div>
        <div className="text-center text-inverse text-opacity-50">Plant People Development Jobsite Maruwai Coal</div>
      </div>
    </div>
  );
}

export default Logingin;
